import React, { createContext } from "react";
import { AgentProviderProps, ConnectifiAgent } from "./types";

export const AgentContext = createContext<ConnectifiAgent | undefined>(
  undefined
);

export function AgentProvider({
  children,
  agent,
}: Readonly<AgentProviderProps>) {
  return (
    <AgentContext.Provider value={agent}>{children}</AgentContext.Provider>
  );
}
